var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uni-async-error",on:{"click":_vm._onClick}},[_vm._v("\n  "+_vm._s(_vm.$$t("uni.async.error"))+"\n")])}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }